import React, { useEffect, createElement } from 'react';
import { SalesPage } from './pages/SalesPage';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    // Meta Pixel Initialization
    const initPixel = () => {
      // @ts-ignore
      if (window.fbq) return;
      // @ts-ignore
      window.fbq = function () {
        // @ts-ignore
        window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
      };
      // @ts-ignore
      if (!window._fbq) window._fbq = window.fbq;
      // @ts-ignore
      window.fbq.push = window.fbq;
      // @ts-ignore
      window.fbq.loaded = true;
      // @ts-ignore
      window.fbq.version = '2.0';
      // @ts-ignore
      window.fbq.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      // @ts-ignore
      window.fbq('init', '1723310688650304');
      // @ts-ignore
      window.fbq('track', 'PageView');
    };
    initPixel();
  }, []);
  return <>
      <SalesPage data-id="element-0" />
      <PurchasePopup data-id="element-1" />
    </>;
}